export interface FooterLink {
  href: string;
  label: string;
}

export interface FooterSection {
  heading: string;
  links: FooterLink[];
}

export const HOMEOWNER_LINKS: FooterLink[] = [
  { href: "/browse", label: "Find a Tradesperson" },
  { href: "/post-job", label: "Post a Job" },
  { href: "/snap", label: "Snap and Fix" },
  { href: "/diagnose", label: "What's Wrong With My House?" },
  { href: "/find", label: "Browse by Location" },
  { href: "/map", label: "Live Map" },
  { href: "/homeowner/saved", label: "Saved Tradespeople" },
  { href: "/ask", label: "Ask a Tradesperson" },
];

export const PRICING_LINKS: FooterLink[] = [
  { href: "/cost-estimator", label: "Cost Estimator" },
  { href: "/prices", label: "Trade Price Index" },
  { href: "/compare", label: "Compare Cities" },
  { href: "/leaderboards", label: "Cost Leaderboards" },
  { href: "/permits", label: "Planning Permission" },
  { href: "/problems", label: "Home Problem Guides" },
  { href: "/guides", label: "Cost Guides" },
];

export const TRADESPERSON_LINKS: FooterLink[] = [
  { href: "/signup/tradesperson", label: "Create a Profile" },
  { href: "/for-tradespeople", label: "Why Join" },
  { href: "/jobs", label: "Job Alerts" },
  { href: "/dashboard", label: "Dashboard" },
  { href: "/refer", label: "Refer a Tradesperson" },
];

export const COMPANY_LINKS: FooterLink[] = [
  { href: "/about", label: "About" },
  { href: "/how-it-works", label: "How It Works" },
  { href: "/contact", label: "Contact" },
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/terms", label: "Terms of Service" },
];

export const SHARED_FOOTER_SECTIONS: FooterSection[] = [
  { heading: "For Homeowners", links: HOMEOWNER_LINKS },
  { heading: "Pricing Tools", links: PRICING_LINKS },
  { heading: "For Tradespeople", links: TRADESPERSON_LINKS },
  { heading: "Company", links: COMPANY_LINKS },
];

export const LANDING_FOOTER_SECTIONS: FooterSection[] = [
  { heading: "For Homeowners", links: HOMEOWNER_LINKS },
  { heading: "Pricing Tools", links: PRICING_LINKS },
  { heading: "For Tradespeople", links: TRADESPERSON_LINKS },
];

export const LANDING_BOTTOM_LINKS: FooterLink[] = [
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
  { href: "/privacy#cookies", label: "Cookies" },
];
